@switch (dataType) {
@case (TAG_DATA_TYPES.DROPDOWN) {
<div class="relative inline-flex items-center py-1 px-2 rounded-full bg-arena-orange-300 text-nowrap">
    <span class="text-xs" [pTooltip]="value" tooltipPosition="top">{{value | truncate:45}}</span>
    <i class="pi pi-times-circle cursor-pointer ml-2" (click)="deleteTag()"></i>
    <img src="icons/star.svg" pTooltip="AI Generated" tooltipPosition="top"
        class="absolute -top-1 -right-1 h-4 w-4 border border-arena-orange-300 rounded-full bg-white p-0.5 shadow"
        alt="Star icon">
</div>
}
@case (TAG_DATA_TYPES.NUMBER) {
<input pInputText type="number" [(ngModel)]="value" [disabled]="!onEdit" [pTooltip]="value" tooltipPosition="top"
    class="w-[10rem] bg-white flex-1 outline-none rounded-base border border-gray-300 p-2"
    (ngModelChange)="valueChanged()" />
}
@case (TAG_DATA_TYPES.DATE) {
<app-datepicker [(value)]="value" [config]="{
    disabled: !onEdit,
    iconDisplay: 'input',
    showIcon: true,
    appendTo: 'body'
}" [pTooltip]="(value|date)??'-'" tooltipPosition="top" (onSelect)="valueChanged()" />
}
@case (TAG_DATA_TYPES.TEXT) {
<input type="text" [disabled]="!onEdit" class="w-[10rem] bg-white rounded-base border border-gray-300 p-2 text-sm"
    [(ngModel)]="value" [pTooltip]="value" tooltipPosition="top" (ngModelChange)="valueChanged()">
}
@default {
<div class="w-[10rem] rounded-base border border-gray-300 bg-white p-2">
    <span class="text-xs block truncate" [pTooltip]="value" tooltipPosition="top">{{value | truncate:45}}</span>
</div>
}
}